import {toast} from "react-toastify";
import ExcelJS from 'exceljs';

import formatearNumero from "../../helpers/datos/formatearNumero";
import mensajePreventivo from "../../helpers/mensajes/mensajePreventivo";

export default function generarExcel(primavera1, primavera2, valoresReporteGeneral, listaEstatus, listaUsuarios, usuarios) {
    console.log(usuarios)

    for (let i = 0; i < valoresReporteGeneral.length; i++) {
        let usuarioEncontrado = usuarios.filter(item => item.userID === valoresReporteGeneral[i].idUsuarioElabora)[0].name;
        valoresReporteGeneral[i].usuario = usuarioEncontrado ?? "Sin usuario";
    }

    /* Se requiere de lista de estatus y usuarios paara generar archivo extensión .xlsx */
    if (listaEstatus.length < 1 || listaUsuarios.length < 1) {
        if (listaEstatus.length < 1) mensajePreventivo("Seleccione algunos estatus");
        else mensajePreventivo("Seleccione algunos usuarios")
    }

    else {
        const id = toast.loading("Please wait...")
        if (valoresReporteGeneral.length > 0) {
            var b = null
            var c = null
            for (let i = 0; i < valoresReporteGeneral.length; i++) {

                if (i !== valoresReporteGeneral.length - 1) {
                    b = valoresReporteGeneral[i].idPolizaPago
                    c = valoresReporteGeneral[i + 1].idPolizaPago
                    if (b === c) {
                        valoresReporteGeneral[i + 1].importe = " ";
                    }
                }
                else {
                    break
                }
            }
            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet(`Ingresos OP`);
            sheet.properties.defaultRowHeight = 40;

            const descripciones = valoresReporteGeneral.map(item => item.descripcion);
            const cri = valoresReporteGeneral.map(item => item.cri);
            /* const idPolizaPagos = valoresReporteGeneral.map(item => item.idPolizaPago) */

            const longitudDesc = descripciones.sort(function (a, b) { return b.length - a.length; })[0].length ?? 270;
            const longitudCri = cri.sort(function (a, b) { return b.length - a.length; })[0].length ?? 270;
            const colors = ["ECE5C7", "FFFFFF"];

            let headers = [
                {
                    header: "Folio",
                    key: "IdPolizaPago",
                    width: 20,
                    alignment: "center"
                },
                {
                    header: "Fecha de Emision",
                    key: "FechaEmision",
                    width: 30,
                    alignment: "center"
                },
                {
                    header: "FechaPago",
                    key: "FechaPago",
                    width: 25,
                    alignment: "center"
                },
                {
                    header: "Contribuyente",
                    key: "NombreCompleto",
                    width: 70,
                    alignment: "center"
                },
                {
                    header: "Autorización",
                    key: "IdConcesion",
                    width: 25,
                    alignment: "center"
                },
                {
                    header: "Usuario",
                    key: "Usuario",
                    width: 60,
                    alignment: "center"
                },
                {
                    header: "CRI",
                    key: "CRI",
                    width: longitudCri,
                    alignment: "center"
                },
                {
                    header: "Descripcion",
                    key: "Descripcion",
                    width: longitudDesc,
                    alignment: "center"
                },
                {
                    header: "ImporteConcepto",
                    key: "ImporteConcepto",
                    width: 30,
                    alignment: "center"
                },
                {
                    header: "Importe",
                    key: "Importe",
                    width: 30,
                    alignment: "center"
                },
            ];

            sheet.columns = [...headers];

            valoresReporteGeneral.map(item => {
                sheet.addRow({
                    IdPolizaPago: item.idPolizaPago,
                    FechaEmision: item.fechaEmision,
                    FechaPago: item.fechaPago.toUpperCase(),
                    NombreCompleto: item.nombreCompleto.toUpperCase(),
                    IdConcesion: item.idConcesion === 0 ? "SIN AUTORIZACIÓN" : item.idConcesion,
                    Usuario: item.usuario.toUpperCase(),
                    CRI: item.cri,
                    Descripcion: item.descripcion.toUpperCase(),
                    ImporteConcepto: `$${formatearNumero(Number.parseFloat(item.importeConcepto).toFixed(2))}`,
                    Importe: `${item.importe === " " ? item.importe : Number.parseFloat(item.importe).toFixed(2)}`,
                });

            });
            let index = 0;
            for (let i = 0; i < valoresReporteGeneral.length; i++) {
                if (i === 0) {
                    valoresReporteGeneral[0].color = colors[index % 2]
                }
                else if (valoresReporteGeneral[i - 1].idPolizaPago === valoresReporteGeneral[i].idPolizaPago) {
                    valoresReporteGeneral[i].color = colors[index % 2]
                }
                else {
                    index += 1
                    valoresReporteGeneral[i].color = colors[index % 2]
                }
            }

            sheet.eachRow((row, rowNumber) => {
                row.eachCell((cell, colNumber) => {
                    if (cell.value && 1 < cell.row && cell.row <= valoresReporteGeneral.length + 1 && cell.col <= 10) {
                        const currentRow = sheet.getRow(cell.row);
                        currentRow.height = 50;

                        row.getCell(colNumber).fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: valoresReporteGeneral[cell.row - 2].color }
                        }
                        row.getCell(colNumber).alignment = {
                            vertical: "middle",
                            horizontal: "center",

                        }
                        row.getCell(colNumber).border = {
                            top: { style: "thin", color: { argb: "000000" } },
                            bottom: { style: "thin", color: { argb: "000000" } },
                            left: { style: "thin", color: { argb: "000000" } },
                            right: { style: "thin", color: { argb: "000000" } },
                        }

                    }
                });
            });

            sheet.getRow(1).height = 60;
            for (let column = 1; column <= 10; column++) {
                let currentCell = sheet.getCell(1, column);

                currentCell.border = {
                    top: { style: "thin", color: { argb: "000000" } },
                    bottom: { style: "thin", color: { argb: "000000" } },
                    left: { style: "thin", color: { argb: "000000" } },
                    right: { style: "thin", color: { argb: "000000" } },
                }
                currentCell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "Cf5275" }
                }
                currentCell.font = {
                    size: 12,
                    bold: true,
                    color: { argb: 'FFFFFF' },
                }
                currentCell.alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
            }

            /* Se crea el archivo de extensión .xlsx */
            workbook.xlsx.writeBuffer()
                .then(data => {
                    const blob = new Blob([data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheet.sheet",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const anchor = document.createElement("a");
                    anchor.href = url;
                    anchor.download = `Ingresos OP (${primavera1} - ${primavera2}).xlsx`;
                    anchor.click();
                    window.URL.revokeObjectURL(url);
                });
        }
        else {
            mensajePreventivo("No existe información con esos parámetros");
        }
        toast.update(id, { render: "Hecho!", type: "success", isLoading: false, autoClose:500, draggable:true });
    }
}